import { Box, Form, Grid, Select, Text } from '@approvalmax/ui/src/components';
import { domHelpers } from '@approvalmax/utils';
import { memo } from 'react';

import { messages } from './SettingsPart.messages';
import { SettingsPartProps } from './SettingsPart.types';

export const SettingsPart = memo<SettingsPartProps>((props) => {
    const { name, title, accounts, trackingCategories, qa } = props;

    return (
        <div>
            <Form.Part>
                <Box spacing='16 0'>
                    <Text color='midnight80' font='headline' fontSize='xxsmall' fontWeight='medium'>
                        {title}
                    </Text>
                </Box>

                <Grid rowGap={16}>
                    <Select
                        name={`${name}.defaultAccount`}
                        label={messages.defaultAccount}
                        items={accounts}
                        itemNameKey='text'
                        placeholder={messages.defaultAccountPlaceholder}
                        autocomplete
                        qa={domHelpers.generateDataQa(qa, 'default-account-editor')}
                    />

                    {trackingCategories[0] && (
                        <Select
                            name={`${name}.trackingCategory1`}
                            itemNameKey='text'
                            label={trackingCategories[0].category.text}
                            items={trackingCategories[0].options}
                            placeholder={messages.trackingCategoryPlaceholder({
                                name: trackingCategories[0].category.text,
                            })}
                            autocomplete
                            qa={domHelpers.generateDataQa(qa, 'tracking-category-1-editor')}
                        />
                    )}

                    {trackingCategories[1] && (
                        <Select
                            name={`${name}.trackingCategory2`}
                            itemNameKey='text'
                            label={trackingCategories[1].category.text}
                            items={trackingCategories[1].options}
                            placeholder={messages.trackingCategoryPlaceholder({
                                name: trackingCategories[1].category.text,
                            })}
                            autocomplete
                            qa={domHelpers.generateDataQa(qa, 'tracking-category-2-editor')}
                        />
                    )}
                </Grid>
            </Form.Part>
        </div>
    );
});

SettingsPart.displayName = 'SettingsPart';
